const TYPING_TARGET_SELECTOR = "input, textarea, select, [contenteditable]:not([contenteditable='false'])";

/** The hint opens on its own; taking focus from a field the user is typing in would interrupt them. */
export const isUserTyping = (): boolean => document.activeElement?.matches(TYPING_TARGET_SELECTOR) ?? false;
